import { render, staticRenderFns } from "./WorkOrder.vue?vue&type=template&id=bfed22ec&scoped=true"
import script from "./WorkOrder.vue?vue&type=script&lang=js"
export * from "./WorkOrder.vue?vue&type=script&lang=js"
import style0 from "./WorkOrder.vue?vue&type=style&index=0&id=bfed22ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfed22ec",
  null
  
)

export default component.exports